import React, { useState, useEffect, useRef } from 'react';
// import { FaEye, FaDownload } from 'react-icons/fa';
import { Breadcrumb, Layout, Menu, theme, Card } from 'antd';
import Icon, { EyeOutlined, DownloadOutlined, ArrowRightOutlined, DownOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import HLimage from "../../Asset/Images/Home Loan.svg";
import HEmage from "../../Asset/Images/Home Renovation Expansion.svg";
import HLBTimage from "../../Asset/Images/Home Loan Balance Transfer.svg";
import Lapimage from "../../Asset/Images/Loan Against Property.svg";
import homebanner from "../../Asset/Images/Clix Housing Banner.svg";
import gaganimg from "../../Asset/Images/Gagan Aggarwal.png";
import rakeshimg from "../../Asset/Images/Rakesh Kaul.png";
import adityaimg from "../../Asset/Images/Aditya Gupta.png";
import amitimg from "../../Asset/Images/Amit Kumar Jain.png";
import Headers from '../../Components/Header';
import Footers from '../../Components/Footer';
import { Helmet } from "react-helmet";
import PrivacyPolicyContent from '../PrivacyPolicy';
import CookieBanner from '../CookieBanner';
import { Modal } from 'antd';

// Import docs
import PolicyonAppointmentOfSatutory from "../../Asset/Docs/PolicyonAppointmentofStatutoryAuditors.pdf";
import NominationAndRemunerationPolicy from "../../Asset/Docs/Nomination and Remuneration Policy.pdf"
import FairPracticesCode from "../../Asset/Docs/Fair Practices Code.pdf"
import CorporateGovernancePolicy from "../../Asset/Docs/Corporate Governance Policy.pdf"
import RelatedPartyTransactionsPolicy from "../../Asset/Docs/Related Party Transactions Policy.pdf"
import FitandProperCriteriaPolicyforDirectors from "../../Asset/Docs/Fit and Proper Criteria Policy for Directors.pdf"
import TheMostImportantTermsandConditionsMITC from "../../Asset/Docs/The Most Important Terms and Conditions (MITC).pdf"
import ScheduleofCharges from "../../Asset/Docs/Schedule of Charges.pdf"
import VigilMechanism from "../../Asset/Docs/Vigil Mechanism.pdf"
import MoratoriumPolicy from "../../Asset/Docs/Moratorium Policy.pdf"
import Covid19ResolutionPolicy from "../../Asset/Docs/Covid 19 Resolution Policy.pdf"
import KYCAMLPolicy from "../../Asset/Docs/KYC-AML Policy.pdf"
import OperationalGuidelineforHandover from "../../Asset/Docs/Operational Guideline for Handover of Collateral Documents in case of Demise of Borrower.pdf";
import GrievanceRedressalMechanism from "../../Asset/Docs/Grievance Redressal Mechanism.pdf";

import CustomerEducation from "../../Asset/Docs/Customer Education.pdf";
import SecuredAssetsPossessedUnderTheSARFAESI from "../../Asset/Docs/Secured assets possessed under the SARFAESI Act, 2002 - Clix Housing.pdf";
import annualReport23_24 from "../../Asset/Docs/Annual-Report-2023-24.pdf";
import AnnualReport22_23 from "../../Asset/Docs/Annual-Report22_23.pdf";
import annualReport21_22 from "../../Asset/Docs/Annual-Report-Clix-Housing-Finance-21-22_Sd_.pdf";
import mgt7AnnualReport23_24 from "../../Asset/Docs/CHFL-MGT-7-Annual-Return-2023-24.pdf";
import mgt7AnnualReport22_23 from "../../Asset/Docs/Form-MGT-7-Annual-Return_FY-2022-23.pdf";
import mgt7AnnualReport21_22 from "../../Asset/Docs/Form-MGT-7-Annual-Return-_FY-2021-22.pdf";
import mgt7AnnualReport20_21 from "../../Asset/Docs/Form-MGT-7-Annual-Return-_FY-2020-21.pdf";
import disclosureUnderReg11May2023 from "../../Asset/Docs/CH-Disclosure-under-Reg527-and-527A.pdf";
import largeEntityDisclosure23_24 from "../../Asset/Docs/CH-LargeEntityInitialDisclosure-Mar2023.pdf";
import correctioninCRAR from "../../Asset/Docs/CHCorrectioninCRAR.pdf";
import chSecurityCover from "../../Asset/Docs/CHSecurityCover.pdf";
import AuditorCertificateOnStatementOfUtilization from "../../Asset/Docs/AuditedUtilisationandNodeviationcertificate.pdf";
import CHReg52Ratios from "../../Asset/Docs/CHReg52Ratios.pdf";
import AuditedFinancialresults from "../../Asset/Docs/AuditedFinancialresults.pdf";
import CHUnmodifiedOpinion26May2023 from "../../Asset/Docs/CHUnmodifiedOpinion26May2023.pdf";
import CHSignedFSMar22Scanned from "../../Asset/Docs/CH-Signed-FS-Mar22-scanned.pdf";
import SignedFinancialsAndReportMARCH21 from "../../Asset/Docs/Clix-Housing-signed-financials-and-report_MARCH-21-compressed.pdf";
import DirectorReportCHFL2020_21 from "../../Asset/Docs/Director-Report_CHFL_2020-21.pdf";
import AuditorsReportFinancialsCHFL2021Signed from "../../Asset/Docs/Auditors-Report-Financials-CHFL-2021-signed.pdf";
import ClixHousingSignedFinancialsMarch20 from "../../Asset/Docs/Clix-Housing-Signed-Financials-March-20-compressed.pdf";
import ClixHousingAuditedFinancialsFY19bw from "../../Asset/Docs/Clix-Housing-Audited-Financials-FY-19-bw.pdf";
import CHOutcomeofBM09Aug2023 from "../../Asset/Docs/CHOutcomeofBM09Aug2023.pdf";
import CHBMNoticeReg50Aug2023 from "../../Asset/Docs/CHBMNoticeReg50Aug2023.pdf";
import Outcome26July2023 from "../../Asset/Docs/Outcome-26July2023.pdf";
import CHBMNoticeReg50Jul2023 from "../../Asset/Docs/CHBMNoticeReg50Jul2023.pdf";
import CHOutcomeofBM26May2023 from "../../Asset/Docs/CHOutcomeofBM26May2023.pdf";
import CHIntimationOfBM26May2023 from "../../Asset/Docs/CH-Intimation-of-BM-26May2023.pdf";
import outcomeSep2022 from "../../Asset/Docs/outcome.pdf";
import finalAug2022 from "../../Asset/Docs/final.pdf";
import CHCreditRatingJuly2023 from "../../Asset/Docs/CH-Credit-Rating-July-2023.pdf";
import Credit_Rating_Letter_July_6_2022 from "../../Asset/Docs/Credit_Rating_Letter_July_6-2022.pdf"
import lix_Housing_Finance_Limited_Rating_Revalidation_Letter from "../../Asset/Docs/Clix_Housing_Finance_Limited_-_Rating_Revalidation_Letter.pdf";
import CHInvestorComplaintsDisclosureMar2023 from "../../Asset/Docs/CHInvestorComplaintsDisclosureMar2023.pdf";
import DisclosureUnderRegulation13_Mar_2023 from "../../Asset/Docs/Disclosure under Regulation 13(3) – Mar 2023.pdf"
import Clix_Housing_Investor_Grievance_Report_Dec2022 from "../../Asset/Docs/Clix_Housing_Investor_Grievance_Report_Dec2022.pdf";
import Clix_Housing_Investor_Grievance_Report_Sep2022 from "../../Asset/Docs/Clix_Housing_Investor_Grievance_Report_Sep2022.pdf";
import Clix_Housing_Investor_Grievance_Report_Jun2022 from "../../Asset/Docs/Clix_Housing_Investor_Grievance_Report_Jun2022.pdf"
import DisclosureUnderReg6171June2023 from "../../Asset/Docs/Disclosure-under-Reg-6171-June-2023.pdf";
import CHDisclosureUnderReg_6171_12Oct2022 from "../../Asset/Docs/CH-Disclosure-under-reg-6171-12Oct2022.pdf";
import CHDisclosureUnder_73 from "../../Asset/Docs/CH-Disclosure-under-73.pdf";
import CHDisclosure_Under_Reg61_and_71 from "../../Asset/Docs/CH-Disclosure-under-Reg61-and-71.pdf";
import CHDisclosureUnderReg_712_31March2022 from "../../Asset/Docs/CH-Disclosure-under-reg-712-31March2022.pdf";
import CHDRTA from "../../Asset/Docs/RTA.pdf";
import Composition_of_Board_2 from "../../Asset/Docs/Composition-of-Board-2.pdf";
import CHFL_Resignation_of_Directors_1 from "../../Asset/Docs/CHFL-Resignation-of-Directors-1.pdf";
import CH_newspaper_June_2023 from "../../Asset/Docs/CH-newspaper-June-2023.pdf";
import CHNewspaperPublication31Mar2023 from "../../Asset/Docs/CHNewspaperPublication31Mar2023.pdf";
import Financial_Express_15_CHFL_UFR_AD from "../../Asset/Docs/Financial_Express_15.11.2022_CHFL_UFR_AD.pdf";
import EGM_Notice from "../../Asset/Docs/EGM-Notice-09.05.2025.pdf";
import Noticeof8thAGM27thSept2024 from "../../Asset/Docs/Notice-of-8th-AGM-27th-Sept.-2024.pdf";
import AGMproceeding from "../../Asset/Docs/AGM-proceeding.pdf";
import AGMNotice from "../../Asset/Docs/AGM-Notice.pdf";
import Appointment_of_CS from "../../Asset/Docs/Appointment-of-CS.pdf";
import CHReg51GM19Jul2023 from "../../Asset/Docs/CHReg51GM19Jul2023.pdf";
import ClixHousingReg57PaymentConfirmationAprtoJun2023 from "../../Asset/Docs/ClixHousingReg57PaymentConfirmationAprtoJun2023.pdf";
import FinalDraftApplicationAmalgamation from "../../Asset/Docs/Final-Draft-Application-Amalgamation.pdf";
import REGISTREDOFFICE from "../../Asset/Docs/REGISTREDOFFICE.pdf";
import merger from "../../Asset/Docs/merger.pdf"
import Investor_grievances from "../../Asset/Docs/Investor-grievances-status.pdf";
import DirectorAppointmentAB from "../../Asset/Docs/Director-Appointment-AB.pdf";
import Certificate409ClixHousing2022 from "../../Asset/Docs/Certificate409ClixHousing2022.pdf";
import CS from "../../Asset/Docs/CS.pdf";
import DirectorResignation from "../../Asset/Docs/Director-Resignation.pdf";
import kaushikapp from "../../Asset/Docs/kaushikapp-2.pdf";
import Investorgrievances from "../../Asset/Docs/Investorgrievances-1-1.pdf";
import NoticeOf6thAGMCHFL from "../../Asset/Docs/Notice-of-6th-AGM-CHFL_.pdf";
import CHchapterviiiISINspecificationsMarch2023 from "../../Asset/Docs/CHchapterviiiISINspecificationsMarch2023.pdf";
import CHRegulation57paymentconfirmationMarch2023 from "../../Asset/Docs/CHRegulation57paymentconfirmationMarch2023.pdf";
import CHCentralizedDatabase from "../../Asset/Docs/CH-Centralized-Data-base.pdf";
import MaturityPaymenton21Jul2023RecorddateINE0DLP07016 from "../../Asset/Docs/MaturityPaymenton21Jul2023RecorddateINE0DLP07016.pdf"
import CHRecorddateQ127Mar2023 from "../../Asset/Docs/CHRecorddateQ127Mar2023.pdf";
import InterestPaymentConfirmationINE157D07EA3 from "../../Asset/Docs/Interest-Payment-Confirmation-INE157D07EA3_13th-January-2025.pdf"
import CHFLReg57QuarterlyPaymentCertificateSep2023 from "../../Asset/Docs/CHFL-Reg57QuarterlyPaymentCertificateSep2023.pdf"
import DebtMaturityPaymentConfirmationINE0DLP07024 from "../../Asset/Docs/Debt_30092023205856_CH30Sep2023MaturityPaymentConfirmationINE0DLP07024.pdf"
import CHPaymentConfirmationJul from "../../Asset/Docs/CH-Payment-Confirmation-jul-21-2023-1.pdf";
import CHCertificateUnderReg575_28thApril from "../../Asset/Docs/CH-Certificate-under-Reg-575-28th-April-2023.pdf";
import paymentconfirmationscanned31jan2023 from "../../Asset/Docs/paymentconfirmationscanned31jan2023.pdf";
import HalfYearlyStatementOfNCDs from "../../Asset/Docs/Half-Yearly-Statement-of-NCDs-2.pdf";
import PaymentConfirmationOct from "../../Asset/Docs/Payment-Confirmation-Oct-102022.pdf";
import PaymentConfirmationOct9 from "../../Asset/Docs/Payment-Confirmation-Oct-92022-1.pdf";
import CHpaymentconfirmationfinterestandredepmtionOct3 from "../../Asset/Docs/CH-paymentconfirmationfinterestandredepmtion-Oct3-2022.pdf";
import NCDPaymentSept2022 from "../../Asset/Docs/NCD-Payment-Sept-2022.pdf"
import PaymentofInterestRedemptionAmountInTermsOfRegulationMarch from "../../Asset/Docs/Payment-of-Interest-Redemption-Amount-in-terms-of-Regulation-March-21-22.pdf";
import PaymentofInterestQuarterApril_June from "../../Asset/Docs/Payment-of-Interest-for-the-quarter-April-2022-to-June-2022.pdf"
import CHFinancialJune23signed from "../../Asset/Docs/CHFinancialJune23signed.pdf"
import LimitedReviewReport from "../../Asset/Docs/Limited-Review-Report.pdf";
import RatiosDisclosure from "../../Asset/Docs/Ratios-Disclosure.pdf";
import SecurityCover from "../../Asset/Docs/Security-Cover.pdf";
import CHOutcomeofBM09Aug2023_1 from "../../Asset/Docs/CHOutcomeofBM09Aug2023 (1).pdf";
import CHUtilisationandDeviationStatement_June2023 from "../../Asset/Docs/CHUtilisationandDeviationStatement_June2023.pdf";
import DeviationStatementunderRegulation from "../../Asset/Docs/CHUtilisationandDeviationStatement_June2023 (2).pdf";
import CHBMNoticeReg50Aug2023_1 from "../../Asset/Docs/CHBMNoticeReg50Aug2023 (1).pdf";
import assetcover from "../../Asset/Docs/assetcover.pdf";
import FINACIAL from "../../Asset/Docs/FINACIAL.pdf";
import LRR from "../../Asset/Docs/LRR.pdf";
import CertificateFormatAssetCoverCHSept22 from "../../Asset/Docs/Certificate-Format-Asset-Cover-CH-Sept-22.pdf";
import SCRAnnexureAVPRR from "../../Asset/Docs/SCR-annexure-AVPRR.pdf";
import Unmodifieddec from "../../Asset/Docs/Unmodifieddec.pdf";
import CHFL300622 from "../../Asset/Docs/CHFL300622.pdf";
import LRRJUNE22 from "../../Asset/Docs/LRRJUNE22.pdf"
import AuditedAnnualFinancials_2021_22 from "../../Asset/Docs/Audited Annual Financials_2021-22.pdf";
import DirectorReport_2021_22 from "../../Asset/Docs/Director's Report_2021-22.pdf";
import AuditedAnnualFinancials_2020_21 from "../../Asset/Docs/Audited Annual Financials_2020-21.pdf";
import DirectorReport_2020_21 from "../../Asset/Docs/Director's Report_2020-21.pdf"
import AnnualReport_2019_20 from "../../Asset/Docs/Annual Report_2019-20.pdf";
import IntimationofBoardMeeting2ndDec2022 from "../../Asset/Docs/Intimation of Board Meeting- 2nd Dec., 2022.pdf";
import IntimationofBoardMeeting10thAug2022 from '../../Asset/Docs/Intimation of Board Meeting- 10th Aug., 2022.pdf';
import IntimationofBoardMeeting13thFeb2023 from '../../Asset/Docs/Intimation of Board Meeting- 13th Feb., 2023.pdf';
import IntimationofBoardMeeting14thNov2022_Updated from '../../Asset/Docs/Intimation of Board Meeting- 14th Nov., 2022_Updated.pdf';
import IntimationofBoardMeeting14thNov2022 from '../../Asset/Docs/Intimation of Board Meeting- 14th Nov., 2022.pdf';
import IntimationofBoardMeeting22ndSept2022 from '../../Asset/Docs/Intimation of Board Meeting- 22nd Sept., 2022.pdf'
import IntimationofBoardMeeting30thMay2022 from '../../Asset/Docs/Intimation of Board Meeting- 30th May, 2022.pdf'
import OutcomeofBoardMeeting2ndDec2022 from '../../Asset/Docs/Outcome of Board Meeting- 2nd Dec., 2022.pdf'
import OutcomeofBoardMeeting10thAug2022 from '../../Asset/Docs/Outcome of Board Meeting- 10th Aug., 2022.pdf'
import OutcomeofBoardMeeting13thFeb2023 from '../../Asset/Docs/Outcome of Board Meeting- 13th Feb., 2023.pdf'
import OutcomeofBoardMeeting14thNov2022 from '../../Asset/Docs/Outcome of Board Meeting- 14th Nov., 2022.pdf'
import OutcomeofBoardMeeting30thMay2022 from '../../Asset/Docs/Outcome of Board Meeting- 30th May, 2022.pdf'
import IntimationofBoardMeeting4thJune2021 from '../../Asset/Docs/Intimation of Board Meeting- 4th June, 2021.pdf';
import IntimationofBoardMeeting12thNov2021 from '../../Asset/Docs/Intimation of Board Meeting- 12th Nov., 2021.pdf';
import IntimationofBoardMeeting14thFeb2022 from '../../Asset/Docs/Intimation of Board Meeting- 14th Feb., 2022.pdf';
import OutcomeofBoardMeeting4thJune2021 from '../../Asset/Docs/Outcome of Board Meeting- 4th June, 2021.pdf';
import OutcomeofBoardMeeting12thNov2021 from '../../Asset/Docs/Outcome of Board Meeting- 12th Nov., 2021.pdf';
import OutcomeofBoardMeeting14thFeb2022 from '../../Asset/Docs/Outcome of Board Meeting- 14th Feb., 2022.pdf';
import IntimationofBoardMeeting3rdSept2020 from '../../Asset/Docs/Intimation of Board Meeting- 3rd Sept., 2020.pdf';
import IntimationofBoardMeeting27thOct2020 from '../../Asset/Docs/Intimation of Board Meeting- 27th Oct., 2020.pdf';
import OutcomeofBoardMeeting27thOct2020 from '../../Asset/Docs/Outcome of Board Meeting- 27th Oct., 2020.pdf';
import CertificateunderRegulation_30thSept2020 from '../../Asset/Docs/Certificate under Regulation 40(9)_30th Sept, 2020.pdf';
import CertificateunderRegulation_31stMar2021 from '../../Asset/Docs/Certificate under Regulation 40(9)_31st Mar, 2021.pdf';
import CertificateunderRegulation_31stMar2022 from '../../Asset/Docs/Certificate under Regulation 40(9)_31st Mar, 2022.pdf';
import CertificateunderRegulation_31stMar2023 from '../../Asset/Docs/Certificate under Regulation 40(9)_31st Mar, 2023.pdf';
import CorporateGovernanceReport_Sept2021 from '../../Asset/Docs/Corporate Governance Report_Sept., 2021.pdf';
import CreditRating19thJuly2021 from '../../Asset/Docs/Credit Rating_19th July, 2021.pdf';
import CreditRating7thJuly2023 from '../../Asset/Docs/Credit Rating_7th July, 2023.pdf';
import DisclosureunderRegulation13Mar2023 from '../../Asset/Docs/Disclosure under Regulation 13(3) – Mar., 2023.pdf';
import DisclosureunderRegulationDec2021 from '../../Asset/Docs/Disclosure under Regulation 13(3) – Dec., 2021.pdf';
import DisclosureunderRegulationJune2021 from '../../Asset/Docs/Disclosure under Regulation 13(3) – June, 2021.pdf';
import DisclosureunderRegulationSept2021 from '../../Asset/Docs/Disclosure under Regulation 13(3) – Sept., 2021.pdf';
import DisclosureunderRegulationDec2020 from '../../Asset/Docs/Disclosure under Regulation 13(3) – Dec., 2020.pdf';
import DisclosureunderRegulation13Mar2021 from '../../Asset/Docs/Disclosure under Regulation 13(3) – Mar., 2021.pdf';
import DisclosureunderRegulation13Sept2020 from '../../Asset/Docs/Disclosure under Regulation 13(3) – Sept., 2020.pdf';
import DisclosureunderReg6_7Dec2022 from '../../Asset/Docs/Disclosure under Reg 6(1) & 7(1)-Dec., 2022.pdf';
import DisclosureunderReg6_7Mar2023 from '../../Asset/Docs/Disclosure under Reg 6(1) & 7(1)-Mar., 2023.pdf';
import DisclosureunderReg6_7Sept2022 from '../../Asset/Docs/Disclosure under Reg 6(1) & 7(1)-Sept., 2022.pdf';
import DisclosureunderReg6June2022 from '../../Asset/Docs/Disclosure under Reg 6(1)-June, 2022.pdf';
import DisclosureunderReg7June2022 from '../../Asset/Docs/Disclosure under Reg 7(1)-June, 2022.pdf';
import DisclosureunderReg7Mar2023 from '../../Asset/Docs/Disclosure under Reg 7(3)-Mar., 2023.pdf';
import DisclosureunderReg6_7Dec2021 from '../../Asset/Docs/Disclosure under Reg 6(1) & 7(1)-Dec., 2021.pdf';
import DisclosureunderReg6Mar2022 from '../../Asset/Docs/Disclosure under Reg 6(1)-Mar., 2022.pdf';
import DisclosureunderReg6Sept2021 from '../../Asset/Docs/Disclosure under Reg 6(1)-Sept., 2021.pdf';
import DisclosureunderReg7Mar2022 from '../../Asset/Docs/Disclosure under Reg 7(1)-Mar., 2022.pdf';
import DisclosureunderReg7Sept2021 from '../../Asset/Docs/Disclosure under Reg 7(1)-Sept., 2021.pdf';
import DisclosureunderReg7_3Mar2022 from '../../Asset/Docs/Disclosure under Reg 7(3)-Mar., 2022.pdf';
import DisclosureunderReg7_3Mar2021 from '../../Asset/Docs/Disclosure under Reg 7(3)-Mar, 2021.pdf';
import DisclosureunderReg7_3Sept2020 from '../../Asset/Docs/Disclosure under Reg 7(3)-Sept., 2020.pdf';
import ClixHousingBranches from '../../Asset/Docs/Clix Housing- Branches.pdf';
import CompositionofBoard from '../../Asset/Docs/Composition of Board.pdf';
import IssueofNCDs_30thSept2021 from '../../Asset/Docs/Issue of NCDs_30th Sept., 2021.pdf';
import LargeEntityDisclosure_29thApril2022 from '../../Asset/Docs/Large Entity Disclosure_29th April, 2022.pdf';
import AGMNotice27_09_2024 from '../../Asset/Docs/AGM Notice- 27.09.2024.pdf';
import AGMNotice29_09_2023 from '../../Asset/Docs/AGM Notice- 29.09.2023.pdf';
import AGMNotice30_09_2022 from '../../Asset/Docs/AGM Notice- 30.09.2022.pdf';
import EGM19_07_2023 from '../../Asset/Docs/EGM- 19.07.2023.pdf';
import DisclosureunderChapterXIV_28thApr2023 from '../../Asset/Docs/Disclosure under ChapterXIV_28th Apr., 2023.pdf';
import EGMOutcome_19thJuly2023 from '../../Asset/Docs/EGM Outcome_19th July, 2023.pdf';
import Intimationof7thAGM_27thSept2023 from '../../Asset/Docs/Intimation of 7th AGM_27th Sept., 2023.pdf';
import Proceedingsof7thAGM_30thSept2023 from '../../Asset/Docs/Proceedings of 7th AGM_30th Sept., 2023.pdf';
import AppointmentofDirector7thSept2022 from '../../Asset/Docs/Appointment of Director- 7th Sept., 2022.pdf';
import ApprovalofSchemeofMerger_14Nov2022 from '../../Asset/Docs/Approval of Scheme of Merger_14 Nov., 2022.pdf';
import ApprovalofSchemeofMerger_29thNov2022 from '../../Asset/Docs/Approval of Scheme of Merger_29th Nov., 2022.pdf';
import ResignationofCompanySecretary_13thFeb2023 from '../../Asset/Docs/Resignation of Company Secretary_13th Feb, 2023.pdf';
import ResignationofWholeTimeDirector_19thOct2022 from '../../Asset/Docs/Resignation of Whole Time Director_19th Oct., 2022.pdf';
import ShiftingofRegisteredOffice_23rdNov2022 from '../../Asset/Docs/Shifting of Registered Office_23rd Nov., 2022.pdf';
import UpdateonMerger_30thMay2022 from '../../Asset/Docs/Update on Merger_30th May., 2022.pdf';
import Announcement_9thFeb2022 from '../../Asset/Docs/Announcement_9th Feb., 2022.pdf';
import AppointmentofCompanySecretary_19thSept2021 from '../../Asset/Docs/Appointment of Company Secretary_19th Sept., 2021.pdf';
import AppointmentofDirector_10thSept2021 from '../../Asset/Docs/Appointment of Director_10th Sept, 2021.pdf';
import AppointmentofStatutoryAuditor_4thOct2021 from '../../Asset/Docs/Appointment of Statutory Auditor_4th Oct., 2021.pdf';
import MergerwithHoldingCompany_14thFeb2022 from '../../Asset/Docs/Merger with Holding Company_14th Feb., 2022.pdf';
import ResignationofCEO_9thOct2021 from '../../Asset/Docs/Resignation of CEO_9th Oct., 2021.pdf';
import ResignationofCompanySecretary_24thApr2021 from '../../Asset/Docs/Resignation of Company Secretary_24th Apr., 2021.pdf';
import AppointmentofDirectorRBIApproval_18thNov2020 from '../../Asset/Docs/Appointment of Director- RBI Approval_18th Nov., 2020.pdf';
import ChangeinDirectors_17thFeb2021 from '../../Asset/Docs/Change in Directors_17th Feb., 2021.pdf';
import Conversion_PrivatetoPublic_2ndSept2020 from '../../Asset/Docs/Conversion_Private to Public_2nd Sept., 2020.pdf';
import DisclosureunderRegulation_Mar2021 from '../../Asset/Docs/Disclosure under Regulation 52(5)_Mar., 2021.pdf';
import DisclosureunderRegulation_Sept2020 from '../../Asset/Docs/Disclosure under Regulation 52(5)_Sept., 2020.pdf';
import ResignationofDirector_20thNov2020 from '../../Asset/Docs/Resignation of Director_20th Nov., 2020.pdf';
import StatementofISINs_Sept2020 from '../../Asset/Docs/Statement of ISINs_Sept., 2020.pdf';
import Confirmation_InterestPaymentRedemption_INE0DLP07016_21stJuly2023 from '../../Asset/Docs/Confirmation_Interest Payment & Redemption_INE0DLP07016_21st July, 2023.pdf';
import Confirmation_InterestPayment_INE0DLP07024_30thJune2023 from '../../Asset/Docs/Confirmation_Interest Payment_INE0DLP07024_30th June, 2023.pdf';
import Confirmation_InterestPayment_INE0DLP07024_30thSept2023 from '../../Asset/Docs/Confirmation_Interest Payment_INE0DLP07024_30th Sept., 2023.pdf';
import Confirmation_PaymentofInterestonNCDsforquarterJune2023 from '../../Asset/Docs/Confirmation_Payment of Interest on NCDs for quarter June, 2023.pdf';
import Confirmation_PaymentofInterestonNCDsforquarterSept2023 from '../../Asset/Docs/Confirmation_Payment of Interest on NCDs for quarter Sept., 2023.pdf';
import Intimation_PaymentofInterestPrincipalonNCDs_15thJune2023 from '../../Asset/Docs/Intimation_Payment of Interest & Principal on NCDs_15th June, 2023.pdf';
import Intimation_PaymentofInterestonNCDsforquarterJune2023 from '../../Asset/Docs/Intimation_Payment of Interest on NCDs for quarter June, 2023 (Record Date).pdf';
import Intimation_PaymentofInterestonNCDsforquarterJune12023 from '../../Asset/Docs/Intimation_Payment of Interest on NCDs for quarter June, 2023.pdf';
import Intimation_PaymentofInterestonNCDsforquarterSept2023 from '../../Asset/Docs/Intimation_Payment of Interest on NCDs for quarter Sept., 2023.pdf';
import Confirmation_InterestPaymentINE0DLP07016_23rdJuly2022 from '../../Asset/Docs/Confirmation_Interest Payment-INE0DLP07016_23rd July, 2022.pdf';
import Confirmation_InterestPaymentINE0DLP07016_30thJune2022 from '../../Asset/Docs/Confirmation_Interest Payment-INE0DLP07016_30th June, 2022.pdf';
import Confirmation_InterestPaymentINE0DLP07024_30thDec2022 from '../../Asset/Docs/Confirmation_Interest Payment-INE0DLP07024_30th Dec., 2022.pdf';
import Confirmation_InterestPaymentINE0DLP07024_30thJune2022 from '../../Asset/Docs/Confirmation_Interest Payment-INE0DLP07024_30th June, 2022.pdf';
import Confirmation_InterestPaymentINE0DLP07024_30thMar2023 from '../../Asset/Docs/Confirmation_Interest Payment-INE0DLP07024_30th Mar., 2023.pdf';
import Confirmation_InterestPaymentINE0DLP07024_30thSept2022 from '../../Asset/Docs/Confirmation_Interest Payment-INE0DLP07024_30th Sept., 2022.pdf';
import Confirmation_PaymentofInterestonNCDsformonthofJune2022 from '../../Asset/Docs/Confirmation_Payment of Interest on NCDs for month of June, 2022.pdf';
import Confirmation_PaymentofInterestonNCDsforquarterDec2022 from '../../Asset/Docs/Confirmation_Payment of Interest on NCDs for quarter Dec., 2022.pdf';
import Confirmation_PaymentofInterestonNCDsforQuarterMar2023 from '../../Asset/Docs/Confirmation_Payment of Interest on NCDs for quarter Mar., 2023.pdf';
import Confirmation_PaymentofInterestonNCDsforquarterSept2023_1 from '../../Asset/Docs/Confirmation_Payment of Interest on NCDs for quarter Sept., 2022.pdf';
import Intimation_PaymentofInterestonNCDsformonthofJune2022 from '../../Asset/Docs/Intimation_Payment of Interest on NCDs for month of June, 2022.pdf';
import Intimation_PaymentofInterestonNCDsforquarterDec2022 from '../../Asset/Docs/Intimation_Payment of Interest on NCDs for quarter Dec., 2022.pdf';
import Intimation_PaymentofInterestonNCDsforquarterJune2022 from '../../Asset/Docs/Intimation_Payment of Interest on NCDs for quarter June, 2022.pdf';
import Intimation_PaymentofInterestonNCDsforquarterMar2023 from '../../Asset/Docs/Intimation_Payment of Interest on NCDs for quarter Mar., 2023.pdf';
import Intimation_PaymentofInterestonNCDsforquarterSept2022 from '../../Asset/Docs/Intimation_Payment of Interest on NCDs for quarter Sept., 2022.pdf';
import Confirmation_InterestPaymentINE0DLP07024_31stMar2022 from '../../Asset/Docs/Confirmation_Interest Payment-INE0DLP07024_31st Mar., 2022.pdf';
import Confirmation_PaymentofInterestonNCDsformonthofJuly2021 from '../../Asset/Docs/Confirmation_Payment of Interest on NCDs for month of July, 2021.pdf';
import Confirmation_PaymentofInterestonNCDsforquarterDec2021 from '../../Asset/Docs/Confirmation_Payment of Interest on NCDs for quarter Dec., 2021.pdf';
import Confirmation_PaymentofInterestonNCDsforquarterSept2021 from '../../Asset/Docs/Confirmation_Payment of Interest on NCDs for quarter Sept., 2021.pdf';
import Intimation_PaymentofInterestonNCDsformonthofJuly2021 from '../../Asset/Docs/Intimation_Payment of Interest on NCDs for month of July, 2021.pdf';
import Intimation_PaymentofInterestonNCDsforquarterMar2022 from '../../Asset/Docs/Intimation_Payment of Interest on NCDs for quarter Mar., 2022.pdf';
import Confirmation_PaymentofInterestonNCDsforquarterMar2021 from '../../Asset/Docs/Confirmation_Payment of Interest on NCDs for quarter Mar., 2021.pdf';
import Confirmation_PaymentofInterestonNCDs_04Nov2020 from '../../Asset/Docs/Confirmation_Payment of Interest on NCDs_04 Nov, 2020.pdf';
import SpecificationsrelatedtoISINfordebtSecurities_12thApr2023 from '../../Asset/Docs/Specifications related to ISIN for debt Securities_12th Apr.,2023.pdf';
import SpecificationsrelatedtoISINfordebtSecurities_15thApr2021 from '../../Asset/Docs/Specifications related to ISIN for debt Securities_15th Apr.,2021.pdf';
import SpecificationsrelatedtoISINfordebtSecurities_18thOct2022 from '../../Asset/Docs/Specifications related to ISIN for debt Securities_18th Oct.,2022.pdf';
import SpecificationsrelatedtoISINfordebtSecurities_19thApr2022 from '../../Asset/Docs/Specifications related to ISIN for debt Securities_19th Apr.,2022.pdf';
import TradingWindowClosure30thJune2023 from '../../Asset/Docs/Trading Window Closure- 30th June, 2023.pdf';
import LimitedReviewReportJune2023 from '../../Asset/Docs/Limited Review Report- June, 2023.pdf';
import QuarterlyFinancialsJune2023 from '../../Asset/Docs/Quarterly Financials- June, 2023.pdf';
import SecurityCoverJune2023 from '../../Asset/Docs/Security Cover- June, 2023.pdf';
import StatementunderSec52_4ofSEBIRegulations2015June2023 from '../../Asset/Docs/Statement under Sec 52(4) of SEBI Regulations, 2015- June, 2023.pdf';
import DeclarationonunmodifiedopinionunderReg_June2022 from '../../Asset/Docs/Declaration on unmodified opinion under Reg.52(3)_June, 2022.pdf';
import LettertoNSE_10thAug2022 from '../../Asset/Docs/Letter to NSE_10th Aug., 2022.pdf';
import LimitedReviewReportJune2022 from '../../Asset/Docs/Limited Review Report – June, 2022.pdf';
import QuarterlyFinancialsJune2022 from '../../Asset/Docs/Quarterly Financials- June, 2022.pdf';
import AssetCoverSept2022 from '../../Asset/Docs/Asset Cover- Sept., 2022.pdf';
import DeclarationonunmodifiedopinionunderRegSept2022 from '../../Asset/Docs/Declaration on unmodified opinion under Reg.52(3)_Sept.,2022.pdf';
import QuarterlyFinancialsSept2022 from '../../Asset/Docs/Quarterly Financials- Sept., 2022.pdf';
import ReviewReportSept2022 from '../../Asset/Docs/Review Report- Sept., 2022.pdf';
import StatementunderSecofSEBIRegulations2015Sept2022 from '../../Asset/Docs/Statement under Sec 52(4) of SEBI Regulations, 2015- Sept.,2022.pdf';
import AssetCover_Dec2022 from '../../Asset/Docs/Asset Cover_Dec., 2022.pdf';
import DeclarationonunmodifiedopinionunderRegDec2022 from '../../Asset/Docs/Declaration on unmodified opinion under Reg.52(3)_Dec., 2022.pdf';
import LimitedReviewReport_Dec2022 from '../../Asset/Docs/Limited Review Report_Dec., 2022.pdf';
import QuarterlyFinancials_Dec2022 from '../../Asset/Docs/Quarterly Financials_Dec., 2022.pdf';
import StatementunderSecofSEBIRegulations2015_Dec2022 from '../../Asset/Docs/Statement under Sec 52(4) of SEBI Regulations, 2015_Dec., 2022.pdf';
import AssetCover_Mar2023 from '../../Asset/Docs/Asset Cover_Mar., 2023.pdf';
import AuditorCertificate_Mar2023 from "../../Asset/Docs/Auditor's Certificate_Mar., 2023.pdf";
import CorrectionwithrespecttoCRAR_10thJune2023 from '../../Asset/Docs/Correction with respect to CRAR_10th June, 2023.pdf';
import DeclarationonunmodifiedopinionunderReg_Mar2023 from '../../Asset/Docs/Declaration on unmodified opinion under Reg.52(3)_Mar., 2023.pdf';
import Financials_Mar2023 from '../../Asset/Docs/Financials_Mar., 2023.pdf';
import StatementunderRegulationofSEBIRegulations2015_Mar2023 from '../../Asset/Docs/Statement under Regulation 52(4) of SEBI Regulations, 2015_Mar., 2023.pdf';
import StatementunderRegulation_Mar2023 from '../../Asset/Docs/Statement under Regulation 52(7) & 52(7A)_Mar., 2023.pdf';
import LettertoNSE_12thNov2021 from '../../Asset/Docs/Letter to NSE_12th Nov., 2021.pdf';
import LimitedReviewReportSept2021 from '../../Asset/Docs/Limited Review Report-Sept., 2021.pdf';
import QuarterlyFinancialsSept2021 from '../../Asset/Docs/Quarterly Financials-Sept., 2021.pdf';
import StatementunderRegulation_Sept2021 from '../../Asset/Docs/Statement under Regulation 52(7)_Sept., 2021.pdf';
import StatementunderSecofSEBIRegulations2015_Sept2021 from '../../Asset/Docs/Statement under Sec 52(4) of SEBI Regulations, 2015_Sept.,2021.pdf';
import LettertoNSE14thFeb2022 from '../../Asset/Docs/Letter to NSE-14th Feb., 2022.pdf';
import LimitedReviewReportDec2021 from '../../Asset/Docs/Limited Review Report-Dec.,2021.pdf';
import QuarterlyFinancialsDec2021 from '../../Asset/Docs/Quarterly Financials-Dec., 2021.pdf';
import StatementunderRegulationDec2021 from '../../Asset/Docs/Statement under Regulation 52(7) -Dec., 2021.pdf';
import StatementunderSecofSEBIRegulations2015Dec2021 from '../../Asset/Docs/Statement under Sec 52(4) of SEBI Regulations, 2015-Dec., 2021.pdf';
import AuditorReportMar2022 from "../../Asset/Docs/Auditor's Report_Mar., 2022.pdf";
import Fiancials_Mar2022 from '../../Asset/Docs/Fiancials_Mar., 2022.pdf';
import LettertoNSE_Mar2022 from '../../Asset/Docs/Letter to NSE_Mar., 2022.pdf';
import StatementunderRegulation_Mar2022 from '../../Asset/Docs/Statement under Regulation 52(7)_Mar., 2022.pdf';
import StatementunderSec52ofSEBIRegulations2015_Mar2022 from '../../Asset/Docs/Statement under Sec 52(4) of SEBI Regulations, 2015_Mar.,2022.pdf';
import FinancialsSept2020 from '../../Asset/Docs/Financials-Sept., 2020.pdf';
import LimitedReviewReportSept2020 from '../../Asset/Docs/Limited Review Report-Sept., 2020.pdf';
import StatementunderRegulation52Sept2020 from '../../Asset/Docs/Statement under Regulation 52(7) & 52(7A)-Sept, 2020.pdf';
import StatementunderSecofSEBIRegulations2015Sept2020 from '../../Asset/Docs/Statement under Sec 52(4) of SEBI Regulations, 2015- Sept., 2020.pdf';
import AuditorReport_Mar2021 from "../../Asset/Docs/Auditor's Report_Mar2021.pdf";
import FinancialResults_Mar2021 from '../../Asset/Docs/Financial Results_Mar.,2021.pdf';
import StatementunderRegulation_Mar2021 from '../../Asset/Docs/Statement under Regulation 52(7) & 52(7A)_Mar, 2021.pdf';
import StatementunderSecofSEBIRegulations2015_Mar2021 from '../../Asset/Docs/Statement under Sec 52(4) of SEBI Regulations, 2015_Mar.,2021.pdf';
import PubDIscCHMarch24final from '../../Asset/Docs/Pub-DIsc-CH-March-24-final.pdf';
import PublicDisclosureDec23CH from '../../Asset/Docs/Public-DisclosureDec-23-CH.pdf';
import PublicDisclosureCHSepFinal from '../../Asset/Docs/Public-Disclosure-CH-Sep-Final.pdf';
import PublicDIscCH from '../../Asset/Docs/Public-DIsc-CH.pdf';
import PublicDisclosureCHHMarbasedonauditedfinancials561 from '../../Asset/Docs/Public-Disclosure-CH_-Mar_based-on-audited-financials56-1.pdf';
import PublicDisclosureCHDec24 from '../../Asset/Docs/Public-Disclosure-CH_Dec-24.pdf';
import PublicDisclosureCHSep24 from '../../Asset/Docs/Public-Disclosure-CH-Sep-24.pdf';
import PublicDisclosureCHJun24 from '../../Asset/Docs/Public-Disclosure-CH-Jun24.pdf';
import ClixHousingPublicdisclosure from '../../Asset/Docs/Clix-Housing-Public-disclosure.pdf';
import PublicDisclosureCHDec22 from '../../Asset/Docs/Public-Disclosure-CH-Dec22.pdf';
import LiquidityDisclosureClixHousingQ2FY23 from '../../Asset/Docs/Liquidity-Disclosure-Clix-Housing-Q2FY23.pdf';
import LiquidityDisclosureClixHousingQ1FY23 from '../../Asset/Docs/Liquidity-Disclosure-Clix-Housing-Q1FY23.pdf';
import LiquidityDisclosureClixHousingQ3FY21 from '../../Asset/Docs/Liquidity-Disclosure-Clix-Housing-Q3FY21 (2).pdf';
import LiquidityDisclosureClixHousingQ4FY21 from '../../Asset/Docs/Liquidity-Disclosure-Clix-Housing-Q4FY21.pdf';
import LiquidityDisclosureClixHousingQ1FY22 from '../../Asset/Docs/Liquidity-Disclosure-Clix-Housing-Q1FY22.pdf';
import LiquidityDisclosureClixHousingQ2FY22 from '../../Asset/Docs/Liquidity-Disclosure-Clix-Housing-Q2FY22.pdf';
import LiquidityDisclosureClixHousingQ3FY22 from '../../Asset/Docs/Liquidity-Disclosure-Clix-Housing-Q3FY22.pdf';
import LiquidityDisclosureClixHousingQ4FY22 from '../../Asset/Docs/Liquidity-Disclosure-Clix-Housing-Q4FY22.pdf';
import OutcomeofBoardMeeting17thAug2023 from '../../Asset/Docs/Outcome of Board Meeting- 17th Aug., 2023.pdf';
import ResignationofDirectors from '../../Asset/Docs/Resignation of Directors.pdf';
import LettertoNSE_10thAug2022_1 from '../../Asset/Docs/Letter to NSE_10th Aug., 2022.pdf';
import QuarterlyFinancialsJune2022_ from '../../Asset/Docs/Quarterly Financials-June., 2022.pdf';
import StatementunderSecofSEBIRegulations2015_June2022 from '../../Asset/Docs/Statement under Sec 52(4) of SEBI Regulations, 2015_June, 2022.pdf';
import DeclarationonunmodifiedopinionunderReg_June2022_1 from '../../Asset/Docs/Declaration on unmodified opinion under Reg.52(3)_June, 2022.pdf';
import LimitedReviewReportJune2022_1 from '../../Asset/Docs/Limited Review Report-June, 2022.pdf';
import CHFL_Resignationof_Directors from "../../Asset/Docs/CHFL- Resignation of Directors.pdf";
import AnnualReport_2024_25 from "../../Asset/Docs/Annual Report- 2024-25 (1).pdf";
import AGM_NOTICE_25_09_2025 from "../../Asset/Docs/AGM Notice- 25.09.2025.pdf";
import CorporateGovernancePolicy_11_2025 from "../../Asset/Docs/Corporate Governance Policy_11_2025.pdf";
import KYCAMLPolicy_11_2025 from "../../Asset/Docs/KYC AML Policy_11_2025.pdf";
import MGT7AnnualReturn_2024_25 from "../../Asset/Docs/MGT- 7 Annual Return 2024-25.pdf";

import './style.css';

const { Header, Content, Footer } = Layout;

const { Meta } = Card;



const data = {
    first: {
        'Annual Report': [
            {
                label: 'FY 2024-25',
                documents: [
                    { name: 'Annual Report FY 2024-25', url: AnnualReport_2024_25 },
                ],
            },
            {
                label: 'FY 2023-24',
                documents: [
                    { name: 'Annual Report FY 2023-24', url: annualReport23_24 },
                ],
            },
            {
                label: 'FY 2022-23',
                documents: [
                    { name: 'Annual Report FY 2022-23', url: AnnualReport22_23 },
                ],
            },
            {
                label: 'FY 2021-22',
                documents: [
                    { name: 'Audited Annual Financials 2021-22', url: AuditedAnnualFinancials_2021_22 },
                    { name: 'Directors Report 2021-22', url: DirectorReport_2021_22 },
                ],
            },
            {
                label: 'FY 2020-21',
                documents: [
                    { name: 'Audited Annual Financials 2020-21', url: AuditedAnnualFinancials_2020_21 },
                    { name: 'Directors Report 2020-21', url: DirectorReport_2020_21 },
                ],
            },
            {
                label: 'FY 2019-20',
                documents: [
                    { name: 'Annual Report 2019-20', url: AnnualReport_2019_20 },
                ],
            },
        ],
        'Annual Return (Form MGT 7)': [
            {
                documents: [
                    { name: 'MGT- 7 Annual Return 2024-25', url: MGT7AnnualReturn_2024_25 },
                ],
            },
            {
                documents: [
                    { name: 'MGT- 7 Annual Return 2023-24', url: mgt7AnnualReport23_24 },
                ],
            },
            {
                documents: [
                    { name: 'MGT- 7 Annual Return 2022-23', url: mgt7AnnualReport22_23 },
                ],
            },
            {
                documents: [
                    { name: 'MGT- 7 Annual Return 2021-22', url: mgt7AnnualReport21_22 },
                ],
            },
            {
                documents: [
                    { name: 'MGT- 7 Annual Return 2020-21', url: mgt7AnnualReport20_21 },
                ],
            },
        ],
        // 'Annual Financial Results Updates': [

        //     {
        //         label: 'FY 2023-24',
        //         documents: [
        //             { name: 'Disclosure under Reg52(7) and 52(7A)-11May23', url: disclosureUnderReg11May2023 },
        //             { name: 'Large entity disclosure for FY 23-24', url: largeEntityDisclosure23_24 },
        //         ],
        //     },
        //     {
        //         label: 'FY 2022-23',
        //         documents: [
        //             { name: 'Correction with respect to CRAR', url: correctioninCRAR },
        //             { name: 'Auditor’s Certificate on Security Cover-FY2022-23', url: chSecurityCover },
        //             { name: 'Auditor’s Certificate on Statement of Utilization/Deviation FY2022-23', url: AuditorCertificateOnStatementOfUtilization },
        //             { name: 'Audited Ratios-31.Mar.2023', url: CHReg52Ratios },
        //             { name: 'Auditor’s Report and Financials–FY2022-23', url: AuditedFinancialresults },
        //             { name: 'Declaration on Reg.52(3)(a)-unmodified opinion-FY2022-23', url: CHUnmodifiedOpinion26May2023 },
        //         ],
        //     },
        //     {
        //         label: 'FY 2021-22',
        //         documents: [
        //             { name: 'Financial Statement FY22', url: CHSignedFSMar22Scanned },
        //         ],
        //     },
        //     {
        //         label: 'FY 2020-21',
        //         documents: [
        //             { name: 'Auditor’s Report FY21', url: SignedFinancialsAndReportMARCH21 },
        //             { name: 'Director’s Report – 2020-21', url: DirectorReportCHFL2020_21 },
        //             { name: 'Auditor’s Report Financials – 2020-21', url: AuditorsReportFinancialsCHFL2021Signed },
        //         ],
        //     },
        //     {
        //         label: 'FY 2019-20',
        //         documents: [
        //             { name: 'Auditor’s Report FY20', url: ClixHousingSignedFinancialsMarch20 },
        //         ],
        //     },
        //     {
        //         label: 'FY 2018-19',
        //         documents: [
        //             { name: 'Auditor’s Report FY19', url: ClixHousingAuditedFinancialsFY19bw },
        //         ],
        //     },
        // ],
        'Board Meetings': [
            {
                label: 'FY 2023-24',
                documents: [
                    { name: 'Outcome of Board Meeting 17th Aug 2023', url: OutcomeofBoardMeeting17thAug2023 },
                    { name: 'Outcome of Board Meeting 9th Aug, 2023', url: CHOutcomeofBM09Aug2023 },
                    { name: 'Intimation of Board Meeting 9th Aug 2023', url: CHBMNoticeReg50Aug2023 },
                    { name: 'Outcome of Board Meeting 26th July, 2023', url: Outcome26July2023 },
                    { name: 'Intimation of Board Meeting 26th July 2023', url: CHBMNoticeReg50Jul2023 },
                    { name: 'Outcome of Board Meeting 26th May, 2023', url: CHOutcomeofBM26May2023 },
                    { name: 'Intimation of Board Meeting 26th May 2023', url: CHIntimationOfBM26May2023 }

                ],
            },
            {
                label: 'FY 2022-23',
                documents: [
                    { name: 'Outcome of Board Meeting 13th Feb 2023', url: OutcomeofBoardMeeting13thFeb2023 },
                    { name: 'Intimation of Board Meeting 13th Feb 2023', url: IntimationofBoardMeeting13thFeb2023 },
                    { name: 'Outcome of Board Meeting 2nd Dec 2022', url: OutcomeofBoardMeeting2ndDec2022 },
                    { name: 'Intimation of Board Meeting 2nd Dec 2022', url: IntimationofBoardMeeting2ndDec2022 },
                    { name: 'Intimation of Board Meeting 14th Nov 2022 Updated', url: IntimationofBoardMeeting14thNov2022_Updated },
                    { name: 'Outcome of Board Meeting 14th Nov 2022', url: OutcomeofBoardMeeting14thNov2022 },
                    { name: 'Intimation of Board Meeting 14th Nov 2022', url: IntimationofBoardMeeting14thNov2022 },
                    { name: 'Intimation of Board Meeting 22nd Sept 2022', url: IntimationofBoardMeeting22ndSept2022 },
                    { name: 'Outcome of Board Meeting 10th Aug 2022', url: OutcomeofBoardMeeting10thAug2022 },
                    { name: 'Intimation of Board Meeting 10th Aug 2022', url: IntimationofBoardMeeting10thAug2022 },
                    { name: 'Outcome of Board Meeting 30th May 2022', url: OutcomeofBoardMeeting30thMay2022 },
                    { name: 'Intimation of Board Meeting 30th May 2022', url: IntimationofBoardMeeting30thMay2022 }

                ],
            },
            {
                label: 'FY 2021-22',
                documents: [
                    { name: 'Outcome of Board Meeting 14th Feb 2022', url: OutcomeofBoardMeeting14thFeb2022 },
                    { name: 'Intimation of Board Meeting 14th Feb, 2022', url: IntimationofBoardMeeting14thFeb2022 },
                    { name: 'Outcome of Board Meeting 12th Nov 2021', url: OutcomeofBoardMeeting12thNov2021 },
                    { name: 'Intimation of Board Meeting 12th Nov 2021', url: IntimationofBoardMeeting12thNov2021 },
                    { name: 'Outcome of Board Meeting 4th June 2021', url: OutcomeofBoardMeeting4thJune2021 },
                    { name: 'Intimation of Board Meeting 4th June, 2021', url: IntimationofBoardMeeting4thJune2021 }

                ]
            },
            {
                label: "FY 2020-21",
                documents: [
                    { name: 'Outcome of Board Meeting 27th Oct 2020', url: OutcomeofBoardMeeting27thOct2020 },
                    { name: 'Intimation of Board Meeting 27th Oct 2020', url: IntimationofBoardMeeting27thOct2020 },
                    { name: 'Intimation of Board Meeting 3rd Sept 2020', url: IntimationofBoardMeeting3rdSept2020 }
                ]
            }
        ],
        'Certificate Under Regulation 40(9)': [
            {
                documents: [
                    { name: 'Certificate under Regulation 40(9) 31st Mar, 2023', url: CertificateunderRegulation_31stMar2023 },
                    { name: 'Certificate under Regulation 40(9) 31st Mar, 2022', url: CertificateunderRegulation_31stMar2022 },
                    { name: 'Certificate under Regulation 40(9) 31st Mar, 2021', url: CertificateunderRegulation_31stMar2021 },
                    { name: 'Certificate under Regulation 40(9) 30th Sept, 2020', url: CertificateunderRegulation_30thSept2020 },
                ]
            },

        ],
        'Corporate Governance Report Under Reg 27': [
            {
                documents: [
                    { name: 'Corporate Governance Report Sept 2021', url: CorporateGovernanceReport_Sept2021 },
                ]
            },
        ],

        'Credit Ratings': [
            {
                label: 'FY 2023-24',
                documents: [
                    { name: 'Credit Rating 7th July 2023', url: CreditRating7thJuly2023 },
                ]
            },
            // {
            //     label: 'FY 2022-23',
            //     documents: [
            //         { name: 'July-22', url: Credit_Rating_Letter_July_6_2022 },
            //     ],
            // },
            {
                label: 'FY 2021-22',
                documents: [
                    { name: 'Credit Rating 19th July 2021', url: CreditRating19thJuly2021 },
                ],
            },

        ],
        'Disclosure Under Regulation 13(3)': [
            {
                label: 'FY 2023-24',
                documents: [
                    { name: 'Disclosure under Regulation 13(3) – June 2023', url: CHInvestorComplaintsDisclosureMar2023 },
                ]
            },
            {
                label: 'FY 2022-23',
                documents: [
                    { name: 'Disclosure under Regulation 13(3) – Mar 2023', url: DisclosureunderRegulation13Mar2023 },
                ],
            },
            {
                label: 'FY 2021-22',
                documents: [
                    { name: 'Disclosure under Regulation 13(3) – Dec 2021', url: DisclosureunderRegulationDec2021 },
                    { name: 'Disclosure under Regulation 13(3) – Sept 2021', url: DisclosureunderRegulationSept2021 },
                    { name: 'Disclosure under Regulation 13(3) – June 2021', url: DisclosureunderRegulationJune2021 },

                ]
            },
            {
                label: 'FY 2020-21',
                documents: [
                    { name: 'Disclosure under Regulation 13(3) – Mar 2021', url: DisclosureunderRegulation13Mar2021 },
                    { name: 'Disclosure under Regulation 13(3) – Dec 2020', url: DisclosureunderRegulationDec2020 },
                    { name: 'Disclosure under Regulation 13(3) – Sept 2020', url: DisclosureunderRegulation13Sept2020 },

                ]
            }
        ],
        'Disclosure under Reg 6(1), 7(1) & 7(3)': [
            {
                label: 'FY 2023-24',
                documents: [
                    { name: 'Disclosure under Reg 6(1) & 7(1)-June 2023', url: DisclosureUnderReg6171June2023 },
                ],
            },
            {
                label: 'FY 2022-23',
                documents: [
                    { name: 'Disclosure under Reg 7(3)-Mar 2023', url: DisclosureunderReg7Mar2023 },
                    { name: 'Disclosure under Reg 6(1) & 7(1)-Mar 2023', url: DisclosureunderReg6_7Mar2023 },
                    { name: 'Disclosure under Reg 6(1) & 7(1)-Dec 2022', url: DisclosureunderReg6_7Dec2022 },
                    { name: 'Disclosure under Reg 6(1) & 7(1)-Sep 2022', url: DisclosureunderReg6_7Sept2022 },
                    { name: 'Disclosure under Reg 6(1)-June 2022', url: DisclosureunderReg6June2022 },
                    { name: 'Disclosure under Reg 7(1)-June 2022', url: DisclosureunderReg7June2022 },

                ],
            },
            {
                label: 'FY 2021-22',
                documents: [
                    { name: 'Disclosure under Reg 7(3)-Mar 2022', url: DisclosureunderReg7_3Mar2022 },
                    { name: 'Disclosure under Reg 7(1)-Mar 2022', url: DisclosureunderReg7Mar2022 },
                    { name: 'Disclosure under Reg 6(1)-Mar 2022', url: DisclosureunderReg6Mar2022 },
                    { name: 'Disclosure under Reg 6(1) & 7(1)-Dec 2021', url: DisclosureunderReg6_7Dec2021 },
                    { name: 'Disclosure under Reg 6(1)-Sept 2021', url: DisclosureunderReg6Sept2021 },
                    { name: 'Disclosure under Reg 7(1)-Sept 2021', url: DisclosureunderReg7Sept2021 },

                ],
            },
            {
                label: 'FY 2020-21',
                documents: [
                    { name: 'Disclosure under Reg 7(3)-Mar 2021', url: DisclosureunderReg7_3Mar2021 },
                    { name: 'Disclosure under Reg 7(3)-Sept 2020', url: DisclosureunderReg7_3Sept2020 },

                ]
            }
        ],
        //commented as we already placed these doc's in some other placeholders
        // 'General Disclosures': [
        //     {
        //         label: 'General Disclosures',
        //         documents: [
        //             { name: 'Clix Housing - Branches', url: ClixHousingBranches },
        //             { name: 'Composition of Board', url: CompositionofBoard },

        //         ],
        //     },

        // ],
        'Issue Of Securities': [
            {
                documents: [
                    { name: 'Issue of NCDs 30th Sept 2021', url: IssueofNCDs_30thSept2021 }
                ]
            }
        ],
        'Large Entity Disclosure': [
            {
                documents: [
                    { name: 'Large Entity Disclosure 29th April 2022', url: LargeEntityDisclosure_29thApril2022 },
                ]
            }
        ],

        'Newspaper Publication': [
            {
                label: 'FY 2023-24',
                documents: [
                    { name: 'Financial-30 June 2023', url: CH_newspaper_June_2023 },
                ],
            },
            {
                label: 'FY 2022-23',
                documents: [
                    { name: 'Audited Financial-31 Mar 2023', url: CHNewspaperPublication31Mar2023 },
                    // { name: 'Financials-Sept, 2022', url: Financial_Express_15_CHFL_UFR_AD },
                ],
            },

        ],
        "Notice Of General Meetings": [
            {
                label: 'AGM',
                documents: [
                    { name: 'AGM Notice- 25.09.2025', url: AGM_NOTICE_25_09_2025 },
                    { name: 'AGM Notice- 27.09.2024', url: AGMNotice27_09_2024 },
                    { name: 'AGM Notice- 29.09.2023', url: AGMNotice29_09_2023 },
                    { name: 'AGM Notice- 30.09.2022', url: AGMNotice30_09_2022 },

                ]
            },
            {
                label: 'EGM',
                documents: [
                    { name: 'EGM Notice- 09.05.2025', url: EGM_Notice },
                    { name: 'EGM Notice- 19.07.2023', url: EGM19_07_2023 },
                ]
            }
        ],
        'Others': [
            {
                label: 'FY 2025-26',
                documents: [
                    { name: 'Resignation Of Directors', url: CHFL_Resignationof_Directors },
                ],
            },
            // {
            //     label: 'FY 2024-25',
            //     documents: [
            //         { name: 'Notice of 8th AGM- 27th Sept, 2024', url: Noticeof8thAGM27thSept2024 },
            //     ],
            // },
            {
                label: 'FY 2023-24',
                documents: [
                    { name: 'Proceedings of 7th AGM 30th Sept 2023', url: Proceedingsof7thAGM_30thSept2023 },
                    { name: 'Intimation of 7th AGM 27th Sept 2023', url: Intimationof7thAGM_27thSept2023 },
                    { name: 'EGM Outcome 19th July 2023', url: EGMOutcome_19thJuly2023 },
                    { name: 'Disclosure under ChapterXIV 28th Apr 2023', url: DisclosureunderChapterXIV_28thApr2023 },

                    // { name: 'AGM Outcome', url: AGMproceeding },
                    // { name: '7th AGM Notice', url: AGMNotice },
                    // { name: 'Appointment of CS', url: Appointment_of_CS },
                    // { name: 'Intimation under Regulation 51-19Jul2023', url: CHReg51GM19Jul2023 },
                    // { name: 'Disclosure under Regulation 57(5)-30Jun2023', url: ClixHousingReg57PaymentConfirmationAprtoJun2023 },
                    // { name: 'Scheme of Amalgamation for Review and Comments', url: FinalDraftApplicationAmalgamation },
                    // { name: 'Change of Registered Office Address', url: REGISTREDOFFICE },
                    // { name: 'Merger with Clix Capital', url: merger },
                    // { name: 'Investor Grievance', url: Investor_grievances },
                    // { name: 'Appointment of Director', url: DirectorAppointmentAB },
                    // { name: 'Certificate under Regulation 40(9)', url: Certificate409ClixHousing2022 },
                    // { name: 'CS Appointment', url: CS },
                    // { name: 'Director Resignation', url: DirectorResignation },
                    // { name: 'Director Change', url: kaushikapp },
                    // { name: 'Investor Grievance', url: Investorgrievances },
                    // { name: 'Notice of 6th AGM', url: NoticeOf6thAGMCHFL },
                ],
            },
            {
                label: 'FY 2022-23',
                documents: [
                    // { name: 'Chapter VIII–ISIN Specification–31.Mar.2023', url: CHchapterviiiISINspecificationsMarch2023 },
                    // { name: 'Disclosure under Regulation 57(5)-31.Mar.2023', url: CHRegulation57paymentconfirmationMarch2023 },
                    // { name: 'Centralized Database for FY 2022-2023', url: CHCentralizedDatabase },
                    { name: 'Resignation of Company Secretary 13th Feb, 2023', url: ResignationofCompanySecretary_13thFeb2023 },
                    { name: 'Approval of Scheme of Merger 29th Nov 2022', url: ApprovalofSchemeofMerger_29thNov2022 },
                    { name: 'Shifting of Registered Office 23rd Nov 2022', url: ShiftingofRegisteredOffice_23rdNov2022 },
                    { name: 'Approval of Scheme of Merger 14 Nov 2022', url: ApprovalofSchemeofMerger_14Nov2022 },
                    { name: 'Resignation of Whole Time Director 19th Oct 2022', url: ResignationofWholeTimeDirector_19thOct2022 },
                    { name: 'Appointment of Director- 7th Sept 2022', url: AppointmentofDirector7thSept2022 },
                    { name: 'Update on Merger 30th May 2022', url: UpdateonMerger_30thMay2022 },

                ],
            },
            {
                label: 'FY 2021-22',
                documents: [
                    { name: 'Merger with Holding Company 14th Feb 2022', url: MergerwithHoldingCompany_14thFeb2022 },
                    { name: 'Announcement 9th Feb 2022', url: Announcement_9thFeb2022 },
                    { name: 'Appointment of Statutory Auditor 4th Oct 2021', url: AppointmentofStatutoryAuditor_4thOct2021 },
                    { name: 'Resignation of CEO 9th Oct 2021', url: ResignationofCEO_9thOct2021 },
                    { name: 'Appointment of Company Secretary 19th Sept 2021', url: AppointmentofCompanySecretary_19thSept2021 },
                    { name: 'Appointment of Director 10th Sept 2021', url: AppointmentofDirector_10thSept2021 },
                    { name: 'Resignation of Company Secretary 24th Apr 2021', url: ResignationofCompanySecretary_24thApr2021 },


                ],
            },
            {
                label: 'FY 2020-21',
                documents: [
                    { name: 'Disclosure under Regulation 52(5) Mar 2021', url: DisclosureunderRegulation_Mar2021 },
                    { name: 'Change in Directors 17th Feb 2021', url: ChangeinDirectors_17thFeb2021 },
                    { name: 'Resignation of Director 20th Nov 2020', url: ResignationofDirector_20thNov2020 },
                    { name: 'Appointment of Director- RBI Approval 18th Nov 2020', url: AppointmentofDirectorRBIApproval_18thNov2020 },
                    { name: 'Conversion Private to Public 2nd Sept 2020', url: Conversion_PrivatetoPublic_2ndSept2020 },
                    { name: 'Disclosure under Regulation 52(5) Sept 2020', url: DisclosureunderRegulation_Sept2020 },
                    { name: 'Statement of ISINs Sept 2020', url: StatementofISINs_Sept2020 },

                ]
            }
        ],
        'Payment of Interest and Principal on NCDs': [
            {
                label: 'FY 2023-24',
                documents: [
                    { name: 'Confirmation Interest Payment 30th Sept 2023 ', url: Confirmation_InterestPayment_INE0DLP07024_30thSept2023 },
                    { name: 'Intimation Payment of Interest on NCDs for quarter Sept 2023', url: Intimation_PaymentofInterestonNCDsforquarterSept2023 },
                    { name: 'Confirmation Payment of Interest on NCDs for quarter Sept 2023', url: Confirmation_PaymentofInterestonNCDsforquarterSept2023 },
                    { name: 'Confirmation Interest Payment & Redemption 21st July 2023', url: Confirmation_InterestPaymentRedemption_INE0DLP07016_21stJuly2023 },
                    { name: 'Confirmation Interest Payment 30th June 2023', url: Confirmation_InterestPayment_INE0DLP07024_30thJune2023 },
                    { name: 'Confirmation Payment of Interest on NCDs for quarter June 2023', url: Confirmation_PaymentofInterestonNCDsforquarterJune2023 },
                    { name: 'Intimation Payment of Interest & Principal on NCDs 15th June, 2023', url: Intimation_PaymentofInterestPrincipalonNCDs_15thJune2023 },
                    { name: 'Intimation Payment of Interest on NCDs for quarter June 2023(Record Date)', url: Intimation_PaymentofInterestonNCDsforquarterJune2023 },
                    { name: 'Intimation Payment of Interest on NCDs for quarter June 2023', url: Intimation_PaymentofInterestonNCDsforquarterJune12023 },

                ],
            },

            {
                label: 'FY 2022-23',
                documents: [
                    { name: 'Confirmation_Interest Payment-INE0DLP07024_30th Mar, 2023', url: Confirmation_InterestPaymentINE0DLP07024_30thMar2023 },
                    { name: 'Confirmation_Payment of Interest on NCDs for quarter Mar, 2023', url: Confirmation_PaymentofInterestonNCDsforQuarterMar2023 },
                    { name: 'Intimation_Payment of Interest on NCDs for quarter Mar, 2023', url: Intimation_PaymentofInterestonNCDsforquarterMar2023 },
                    { name: 'Confirmation_Interest Payment-INE0DLP07024_30th Dec, 2022', url: Confirmation_InterestPaymentINE0DLP07024_30thDec2022 },
                    { name: 'Intimation_Payment of Interest on NCDs for quarter Dec, 2022', url: Intimation_PaymentofInterestonNCDsforquarterDec2022 },
                    { name: 'Confirmation_Payment of Interest on NCDs for quarter Dec, 2022', url: Confirmation_PaymentofInterestonNCDsforquarterDec2022 },
                    { name: 'Confirmation_Interest Payment-INE0DLP07024_30th Sept, 2022', url: Confirmation_InterestPaymentINE0DLP07024_30thSept2022 },
                    { name: 'Confirmation_Payment of Interest on NCDs for quarter Sept, 2022', url: Confirmation_PaymentofInterestonNCDsforquarterSept2023_1 },
                    { name: 'Intimation_Payment of Interest on NCDs for quarter Sept, 2022', url: Intimation_PaymentofInterestonNCDsforquarterSept2022 },
                    { name: 'Confirmation_Interest Payment-INE0DLP07016_23rd July, 2022', url: Confirmation_InterestPaymentINE0DLP07016_23rdJuly2022 },
                    { name: 'Confirmation_Interest Payment-INE0DLP07016_30th June, 2022', url: Confirmation_InterestPaymentINE0DLP07016_30thJune2022 },
                    { name: 'Confirmation_Interest Payment-INE0DLP07024_30th June, 2022', url: Confirmation_InterestPaymentINE0DLP07024_30thJune2022 },
                    { name: 'Confirmation_Payment of Interest on NCDs for month of June, 2022', url: Confirmation_PaymentofInterestonNCDsformonthofJune2022 },
                    { name: 'Intimation_Payment of Interest on NCDs for month of June, 2022', url: Intimation_PaymentofInterestonNCDsformonthofJune2022 },
                    { name: 'Intimation_Payment of Interest on NCDs for quarter June, 2022', url: Intimation_PaymentofInterestonNCDsforquarterJune2022 },
                ],
            },
            {
                label: 'FY 2021-22',
                documents: [
                    { name: 'Confirmation_Interest Payment-INE0DLP07024_31st Mar, 2022', url: Confirmation_InterestPaymentINE0DLP07024_31stMar2022 },
                    { name: 'Intimation_Payment of Interest on NCDs for quarter Mar., 2022', url: Intimation_PaymentofInterestonNCDsforquarterMar2022 },
                    { name: 'Confirmation_Payment of Interest on NCDs for quarter Dec, 2021', url: Confirmation_PaymentofInterestonNCDsforquarterDec2021 },
                    { name: 'Confirmation_Payment of Interest on NCDs for quarter Sept, 2021', url: Confirmation_PaymentofInterestonNCDsforquarterSept2021 },
                    { name: 'Confirmation_Payment of Interest on NCDs for month of July, 2021', url: Confirmation_PaymentofInterestonNCDsformonthofJuly2021 },
                    { name: 'Intimation_Payment of Interest on NCDs for month of July, 2021', url: Intimation_PaymentofInterestonNCDsformonthofJuly2021 },

                ],
            },

            {
                label: 'FY 2020-21',
                documents: [
                    { name: 'Confirmation_Payment of Interest on NCDs for quarter Mar, 2021', url: Confirmation_PaymentofInterestonNCDsforquarterMar2021 },
                    { name: 'Confirmation_Payment of Interest on NCDs_04 Nov, 2020', url: Confirmation_PaymentofInterestonNCDs_04Nov2020 },
                ],
            },
        ],
        'Quarterly Financial Results Updates': [
            {
                label: 'Q1 2023-24',
                documents: [
                    // { name: 'Financial Result', url: CHFinancialJune23signed },
                    // { name: 'Limited Review Report', url: LimitedReviewReport },
                    // { name: 'Ratios', url: RatiosDisclosure },
                    // { name: 'Security Cover', url: SecurityCover },
                    // { name: 'Outcome -9Aug2023', url: CHOutcomeofBM09Aug2023_1 },
                    // { name: 'Utilisation Statement under Regulation 52(7)', url: CHUtilisationandDeviationStatement_June2023 },
                    // { name: 'Deviation Statement under Regulation 52(7A)', url: DeviationStatementunderRegulation },
                    // { name: 'Intimation of Board Meeting-09Aug2023', url: CHBMNoticeReg50Aug2023_1 },
                    { name: 'Limited Review Report- June, 2023', url: LimitedReviewReportJune2023 },
                    { name: 'Quarterly Financials- June, 2023', url: QuarterlyFinancialsJune2023 },
                    { name: 'Security Cover- June, 2023', url: SecurityCoverJune2023 },
                    { name: 'Statement under Sec 52(4) of SEBI Regulations, 2015-June, 2023', url: StatementunderSec52_4ofSEBIRegulations2015June2023 },

                ],
            },
            {
                label: 'Q4 2022-23',
                documents: [
                    { name: 'Correction with respect to CRAR 10th June, 2023', url: CorrectionwithrespecttoCRAR_10thJune2023 },
                    { name: 'Asset Cover Mar, 2023', url: AssetCover_Mar2023 },
                    { name: 'Auditor Certificate Mar, 2023', url: AuditorCertificate_Mar2023 },
                    { name: 'Declaration on unmodified opinion under Reg.52(3) Mar, 2023', url: DeclarationonunmodifiedopinionunderReg_Mar2023 },
                    { name: 'Financials Mar, 2023', url: Financials_Mar2023 },
                    { name: 'Statement under Regulation 52(4) of SEBI Regulations, 2015 Mar, 2023', url: StatementunderRegulationofSEBIRegulations2015_Mar2023 },
                    { name: 'Statement under Regulation 52(7) & 52(7A) Mar, 2023', url: StatementunderRegulation_Mar2023 }
                ],
            },
            {
                label: 'Q3 2022-23',
                documents: [
                    { name: 'Asset Cover_Dec, 2022', url: AssetCover_Dec2022 },
                    { name: 'Declaration on unmodified opinion under Reg.52(3) Dec, 2022', url: DeclarationonunmodifiedopinionunderRegDec2022 },
                    { name: 'Limited Review Report_Dec, 2022', url: LimitedReviewReport_Dec2022 },
                    { name: 'Quarterly Financials_Dec, 2022', url: QuarterlyFinancials_Dec2022 },
                    { name: 'Statement under Sec 52(4) of SEBI Regulations, 2015 Dec, 2022', url: StatementunderSecofSEBIRegulations2015_Dec2022 },

                ],
            },
            {
                label: 'Q2 2022-23',
                documents: [
                    { name: 'Asset Cover- Sept, 2022', url: AssetCoverSept2022 },
                    { name: 'Declaration on unmodified opinion under Reg.52(3) Sept,2022', url: DeclarationonunmodifiedopinionunderRegSept2022 },
                    { name: 'Quarterly Financials- Sept, 2022', url: QuarterlyFinancialsSept2022 },
                    { name: 'Review Report- Sept, 2022', url: ReviewReportSept2022 },
                    { name: 'Statement under Sec 52(4) of SEBI Regulations, 2015 Sept, 2022', url: StatementunderSecofSEBIRegulations2015Sept2022 },

                ],
            },
            {
                label: 'Q1 2022-23',
                documents: [
                    // { name: 'Asset Cover', url: assetcover },
                    // { name: 'Financials', url: FINACIAL },
                    // { name: 'Limited Review Report', url: LRR },
                    // { name: 'Auditor’s Report on NCDs', url: CertificateFormatAssetCoverCHSept22 },
                    // { name: 'SCR Annexure', url: SCRAnnexureAVPRR },
                    { name: 'Declaration on unmodified opinion under Reg.52(3) June, 2022', url: DeclarationonunmodifiedopinionunderReg_June2022 },
                    { name: 'Letter to NSE_10th Aug, 2022', url: LettertoNSE_10thAug2022 },
                    { name: 'Limited Review Report – June, 2022', url: LimitedReviewReportJune2022 },
                    { name: 'Quarterly Financials- June, 2022', url: QuarterlyFinancialsJune2022 },

                ],
            },
            {
                label: 'Q4 2021-22',
                documents: [
                    { name: 'Auditor Report_Mar, 2022', url: AuditorReportMar2022 },
                    { name: 'Fiancials_Mar, 2022', url: Fiancials_Mar2022 },
                    { name: 'Letter to NSE_Mar, 2022', url: LettertoNSE_Mar2022 },
                    { name: 'Statement under Regulation 52(7)_Mar, 2022', url: StatementunderRegulation_Mar2022 },
                    { name: 'Statement under Sec 52(4) of SEBI Regulations, 2015_Mar, 2022', url: StatementunderSec52ofSEBIRegulations2015_Mar2022 },
                ],
            },
            {
                label: 'Q3 2021-22',
                documents: [
                    { name: 'Letter to NSE-14th Feb, 2022', url: LettertoNSE14thFeb2022 },
                    { name: 'Statement under Sec 52(4) of SEBI Regulations, 2015-Dec, 2021', url: StatementunderSecofSEBIRegulations2015Dec2021 },
                    { name: 'Statement under Regulation 52(7) -Dec, 2021', url: StatementunderRegulationDec2021 },
                    { name: 'Quarterly Financials-Dec, 2021', url: QuarterlyFinancialsDec2021 },
                    { name: 'Limited Review Report-Dec, 2021', url: LimitedReviewReportDec2021 }
                ],
            },
            {
                label: 'Q2 2021-22',
                documents: [
                    { name: 'Letter to NSE 12th Nov, 2021.pdf', url: LettertoNSE_12thNov2021 },
                    { name: 'Limited Review Report-Sept, 2021.pdf', url: LimitedReviewReportSept2021 },
                    { name: 'Quarterly Financials-Sept, 2021.pdf', url: QuarterlyFinancialsSept2021 },
                    { name: 'Statement under Regulation 52(7) Sept, 2021.pdf', url: StatementunderRegulation_Sept2021 },
                    { name: 'Statement under Sec 52(4) of SEBI Regulations, 2015_Sept,2021.pdf', url: StatementunderSecofSEBIRegulations2015_Sept2021 },
                ],
            },
            {
                label: 'Q1 2021-22',
                documents: [
                    { name: 'Letter to NSE 10th Aug, 2022', url: LettertoNSE_10thAug2022_1 },
                    { name: 'Quarterly Financials June, 2022', url: QuarterlyFinancialsJune2022_ },
                    { name: 'Statement under Sec 52(4) of SEBI Regulations, 2015_June, 2022', url: StatementunderSecofSEBIRegulations2015_June2022 },
                    { name: 'Declaration on unmodified opinion under Reg June, 2022', url: DeclarationonunmodifiedopinionunderReg_June2022_1 },
                    { name: 'Limited Review Report June, 2022', url: LimitedReviewReportJune2022_1 },
                ],
            },
            {
                label: 'Q4 2020-21',
                documents: [
                    { name: 'Auditor Report_Mar, 2021', url: AuditorReport_Mar2021 },
                    { name: 'Financial Results_Mar, 2021', url: FinancialResults_Mar2021 },
                    { name: 'Statement under Regulation 52(7) & 52(7A)_Mar, 2021', url: StatementunderRegulation_Mar2021 },
                    { name: 'Statement under Sec 52(4) of SEBI Regulations, 2015_Mar, 2021', url: StatementunderSecofSEBIRegulations2015_Mar2021 },

                ],
            },
            {
                label: 'Q3 2020-21',
                documents: [
                    { name: 'Financials-Sept, 2020', url: FinancialsSept2020 },
                    { name: 'Limited Review Report-Sept, 2020', url: LimitedReviewReportSept2020 },
                    { name: 'Statement under Regulation 52(7) & 52(7A)-Sept, 2020', url: StatementunderRegulation52Sept2020 },
                    { name: 'Statement under Sec 52(4) of SEBI Regulations, 2015- Sept, 2020', url: StatementunderSecofSEBIRegulations2015Sept2020 },

                ],
            },
        ],
        'Specifications Related to ISIN for Debt Securities': [
            {
                documents: [
                    { name: 'Specifications related to ISIN for debt Securities_12th Apr,2023', url: SpecificationsrelatedtoISINfordebtSecurities_12thApr2023 },
                    { name: 'Specifications related to ISIN for debt Securities_18th Oct,2022', url: SpecificationsrelatedtoISINfordebtSecurities_18thOct2022 },
                    { name: 'Specifications related to ISIN for debt Securities_19th Apr,2022', url: SpecificationsrelatedtoISINfordebtSecurities_19thApr2022 },
                    { name: 'Specifications related to ISIN for debt Securities_15th Apr,2021', url: SpecificationsrelatedtoISINfordebtSecurities_15thApr2021 },
                ]
            }
        ],
        'Trading Window Closure': [
            {
                documents: [
                    { name: 'Trading Window Closure- 30th June, 2023', url: TradingWindowClosure30thJune2023 },
                ]
            }
        ]
        // 'Record Date Updates': [
        //     {
        //         label: 'FY 2023-24',
        //         documents: [
        //             { name: 'INE0DLP07016-Record Date-Maturity Payment-21July2023', url: MaturityPaymenton21Jul2023RecorddateINE0DLP07016 },
        //             { name: 'Reg. 57(4) – Record Date – Q1- 2023-24', url: CHRecorddateQ127Mar2023 },
        //         ],
        //     },

        // ]



        // Policies starts here
    },
    second: {
        'General': [
            {
                label: 'General',
                documents: [
                    { name: 'Policy on Appointment of Statutory Auditors', url: PolicyonAppointmentOfSatutory },
                    { name: 'Nomination and Remuneration Policy', url: NominationAndRemunerationPolicy },
                    { name: 'Fair Practices Code', url: FairPracticesCode },
                    // { name: 'Corporate Governance Policy', url: CorporateGovernancePolicy },
                    { name: 'Corporate Governance Policy', url: CorporateGovernancePolicy_11_2025 },
                    { name: 'Related Party Transactions Policy', url: RelatedPartyTransactionsPolicy },
                    { name: 'Fit and Proper Criteria Policy for Directors', url: FitandProperCriteriaPolicyforDirectors },
                    { name: 'The Most Important Terms and Conditions (MITC)', url: TheMostImportantTermsandConditionsMITC },
                    { name: 'Schedule of Charges', url: ScheduleofCharges },
                    { name: 'Vigil Mechanism', url: VigilMechanism },
                    { name: 'Moratorium Policy', url: MoratoriumPolicy },
                    { name: 'Covid 19 Resolution Policy', url: Covid19ResolutionPolicy },
                    // { name: 'KYC-AML Policy', url: KYCAMLPolicy },
                    { name: 'KYC-AML Policy', url: KYCAMLPolicy_11_2025 },
                ],
            },

        ],
        'Operational Guidelines': [
            {
                label: 'Operational Guidelines',
                documents: [
                    { name: 'Operational Guideline for Handover of Collateral Documents in case of Demise of Borrower', url: OperationalGuidelineforHandover },
                ],
            },
        ],
        'Disclosures': [
            {
                label: 'Public Disclosure',
                heading: 'FY 2024',
                documents: [
                    { name: 'Q1', url: PublicDIscCH },
                    { name: 'Q2', url: PublicDisclosureCHSepFinal },
                    { name: 'Q3', url: PublicDisclosureDec23CH },
                    { name: 'Q4', url: PubDIscCHMarch24final },
                ],
            },
            {
                label: 'FY 2025',
                // heading: 'FY 2024',
                documents: [
                    { name: 'Q1', url: PublicDisclosureCHJun24 },
                    { name: 'Q2', url: PublicDisclosureCHSep24 },
                    { name: 'Q3', url: PublicDisclosureCHDec24 },
                    { name: 'Q4', url: PublicDisclosureCHHMarbasedonauditedfinancials561 },
                ],
            },
            {
                label: 'Liquidity Disclosure',
                heading: 'FY 2021',
                documents: [
                    // { name: 'Q1', url: '' },
                    // { name: 'Q2', url: '' },
                    { name: 'Q3', url: LiquidityDisclosureClixHousingQ3FY21 },
                    { name: 'Q4', url: LiquidityDisclosureClixHousingQ4FY21 },
                ],
            },
            {
                label: 'FY 2022',
                // heading: 'FY 2023',
                documents: [
                    { name: 'Q1', url: LiquidityDisclosureClixHousingQ1FY22 },
                    { name: 'Q2', url: LiquidityDisclosureClixHousingQ2FY22 },
                    { name: 'Q3', url: LiquidityDisclosureClixHousingQ3FY22 },
                    { name: 'Q4', url: LiquidityDisclosureClixHousingQ4FY22 },
                ],
            },
            {
                label: 'FY 2023',
                // heading: 'FY 2023',
                documents: [
                    { name: 'Q1', url: LiquidityDisclosureClixHousingQ1FY23 },
                    { name: 'Q2', url: LiquidityDisclosureClixHousingQ2FY23 },
                    { name: 'Q3', url: PublicDisclosureCHDec22 },
                    { name: 'Q4', url: ClixHousingPublicdisclosure },
                ],
            }
        ],
        'Grievance Redressal': [
            {
                label: 'Grievance Redressal Mechanism',
                documents: [
                    { name: 'Grievance Redressal Mechanism', url: GrievanceRedressalMechanism },
                ],
            },
        ],
        'Payment Mode': [
            {
                label: 'Payment can be made through electronic modes – Unified Payments Interface (UPI) (BHIM-UPI), Unified Payments Interface Quick Response Code (UPI QR Code) (BHIM-UPI QR Code) and also through Debit Card powered by Rupay',
            }
        ],
        'PLR Rate': [
            {
                label: 'Currently, Clix Housing Finance Limited Prime Lending Rate (“CHPLR”) is 19%',
            }
        ],
        'Customer Education': [
            {
                label: 'Customer Education',
                documents: [
                    { name: 'Customer Education', url: CustomerEducation },
                ],
            },
        ],
        'Properties Under Auction': [
            {
                documents: [
                    { name: 'Secured assets possessed under the SARFAESI Act, 2002 - Clix Housing', url: SecuredAssetsPossessedUnderTheSARFAESI },
                ],
            },
        ]

    }
    // second tab...
};


const Home = () => {

    // Refs for each section
    const homeRef = useRef(null);
    const aboutRef = useRef(null);
    const teamRef = useRef(null);
    const documentsRef = useRef(null);
    const contactRef = useRef(null);

    const [policyOpen, setPolicyOpen] = useState(false);

    const openPolicy = () => setPolicyOpen(true);
    const closePolicy = () => setPolicyOpen(false);

    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    const [activeTab, setActiveTab] = useState('first');

    const [activeDropdown, setActiveDropdown] = useState(null);

    const [expandedSection, setExpandedSection] = useState('Annual Report');

    const [showAllSections, setShowAllSections] = useState(false);
    const sections = Object.entries(data[activeTab]);
    const visibleSections = showAllSections ? sections : sections.slice(0, 7);


    const toggleSection = (section) => {
        setExpandedSection(expandedSection === section ? null : section);
    };


    useEffect(() => {
        setExpandedSection(null);
    }, [activeTab]);


    // const tabData = {
    //     first: {
    //         title: 'Investors',
    //         dropdowns: {
    //             'Annual Report': ['Investor A1', 'Investor A2'],
    //             'Investor Group B': ['Investor B1', 'Investor B2'],
    //         },
    //     },
    //     second: {
    //         title: 'Policies',
    //         dropdowns: {
    //             'Policy Type X': ['Policy X1', 'Policy X2'],
    //             'Policy Type Y': ['Policy Y1', 'Policy Y2'],                                                             
    //         },
    //     },
    // };



    // Get Direction 
    const destination = "28.4942,77.0806"; // Example: Coordinates for Cyber City, Gurugram
    const googleMapsDirectionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${destination}`;


    return (
        <>
            <Helmet>
                <script type="application/ld+json">
                    {`
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Clix Housing",
        "url": "https://clixhousing.com/",
        "logo": "https://www.clix.capital/",
        "sameAs": [
          "https://www.facebook.com/ClixCapital/",
          "https://in.linkedin.com/company/clix-capital"
        ]
      }
    `}
                </script>
                <title>Clix Housing - Official Website for Clix Housing Finance Limited</title>
                <meta
                    name="description"
                    content="Welcome to Clix Housing Finance Limited, your trusted partner in business solutions."
                />
                <meta
                    name="keywords"
                    content="Clix housing,clixhousing.com,Clix,Housing,housing,Clix Housing,
                                 clix housing,Finance,finance,finance limited,Finance Limited,
                                 Finance Limited,Clix Housing Finance Limited"
                />
                https://clixhousing.com/
            </Helmet>

            <Headers
                refs={{
                    homeRef,
                    aboutRef,
                    teamRef,
                    documentsRef,
                    contactRef,
                }}
            />
            <Content className="custom-content">
                <div
                    className="custom-inner-content"
                    style={{
                        background: colorBgContainer,
                        borderRadius: borderRadiusLG,
                    }}
                >
                    <div ref={homeRef} className="scroll-section"> {/* Home Section */}

                        <div className="bannerbox">{<img className="homebanner1" alt="example" src={homebanner} />}</div>
                    </div>

                    <div ref={aboutRef} className="scroll-section">
                        <h1 className='housingHeading'>
                            Clix Housing
                        </h1>

                        <hr className='hrline'></hr>
                        <br />
                        <p className='firstContent'>Clix Housing Finance Limited is a RBI registered Housing Finance Company, incorporated on 2nd December, 2016.<br />
                            <br />It is a wholly owned subsidiary of Clix Capital Services Private Limited. </p>
                        <br />
                        <div className='allCardsWrapper'>
                            <div className="allcards">
                                <Card
                                    className="CardHL"
                                    hoverable
                                    cover={<img className="HLimage" alt="example" src={HLimage} />}

                                >
                                    <Meta title="Home Loan"

                                        description={
                                            <div className="meta-description">
                                                We make your dream of owning a home<br />
                                                come true with quick, simple &<br />
                                                hassle-free home loan solutions
                                            </div>
                                        }

                                    />
                                </Card>

                                <Card
                                    className="CardHE"
                                    hoverable
                                    cover={<img className="HEimage" alt="example" src={HEmage} />}

                                >
                                    <Meta title="Home Renovation/ Expansion"

                                        description={
                                            <div className="HE-meta-description">
                                                Transform your home with ease---<br />
                                                affordable solutions tailored to<br />
                                                your budget
                                            </div>
                                        }

                                    />
                                </Card>

                                <Card
                                    className="CardHLBT"
                                    hoverable
                                    cover={<img className="HLBTimage" alt="example" src={HLBTimage} />}

                                >
                                    <Meta title="Home Loan Balance Transfer"

                                        description={
                                            <div className="HLBT-meta-description">
                                                Lower Interest, reduced EMI's -experience<br />
                                                the benefits of Strategic home loan<br />
                                                balance transfer
                                            </div>
                                        }

                                    />
                                </Card>
                                <Card
                                    className="CardLAP"
                                    hoverable
                                    cover={<img className="LAPimage" alt="example" src={Lapimage} />}

                                >
                                    <Meta title="Loan Against Property"
                                        description={
                                            <div className="LAP-meta-description">
                                                Access the substantial funds by leveraging<br />
                                                your property's value-with competitive<br />
                                                rate and flexible repayment options
                                            </div>
                                        }
                                    />
                                </Card>
                            </div>
                        </div>
                        <div className="scroll-section" ref={teamRef}>

                            {/* About Section */}</div>
                        <h1 className='ourteam'>
                            Our Team
                        </h1>


                        <hr className='hrline'></hr>

                        {/* Our team Block */}
                        <div className="ourteamblock">
                            <div className="GaganBlock">
                                <img
                                    src={gaganimg}
                                    alt="Gagan Aggarwal"
                                    className="gaganimg"
                                />
                                <p className="gaganTag">GAGAN AGGARWAL</p>
                                <p className="director1"> Whole-time Director</p>
                            </div>

                            <div className="RakeshBlock">
                                <img
                                    src={rakeshimg}
                                    alt="Rakesh Kaul"
                                    className="rakeshimg"
                                />
                                <p className="rakeshTag">RAKESH KAUL</p>
                                <p className="director1"> Director</p>
                            </div>

                            <div className="AdityaBlock">
                                <img
                                    src={adityaimg}
                                    alt="Aditya Gupta"
                                    className="adityaimg"
                                />
                                <p className="adityatag">ADITYA GUPTA</p>
                                <p className="director1"> Director</p>
                            </div>

                            <div className="AmitBlock">
                                <img
                                    src={amitimg}
                                    alt="Amit Kumar Jain"
                                    className="amitimg"
                                />
                                <p className="amitTag">AMIT KUMAR JAIN</p>
                                <p className="director1"> Chief Financial Officer</p>
                            </div>
                        </div>
                        {/* Team Section */}</div>
                    <div ref={documentsRef} className="scroll-section"> {/* Documents Section */}
                        {/* Our team Block End*/}
                        <h1 className='impDocs'>
                            Disclosures
                        </h1>

                        <hr className='hrline'></hr>

                        {/* toggle box start */}

                        <div className="toggle-wrapper">
                            {/* Button Box */}
                            <div className="button-container">
                                <button
                                    className={activeTab === 'first' ? 'active' : ''}
                                    onClick={() => setActiveTab('first')}
                                >
                                    Investors
                                </button>
                                <button
                                    className={activeTab === 'second' ? 'active' : ''}
                                    onClick={() => setActiveTab('second')}
                                >
                                    Policies
                                </button>
                            </div>

                            {/* Content Box */}
                            <div className="document-wrapper">

                                {visibleSections.map(([section, items]) => (


                                    <div key={section} className="section">
                                        <button className="section-header" onClick={() => toggleSection(section)}>
                                            <span>{section}</span>
                                            <DownOutlined />
                                        </button>
                                        {expandedSection === section && (
                                            <ul className="section-content">
                                                {Array.isArray(items) &&
                                                    items.map((item, index) => (
                                                        <div key={index} className="fiscal-year-section">
                                                            <h3 className="fiscalHeading">{item.label}</h3>
                                                            {item.heading && <h4 className="fiscalSubHeading">{item.heading}</h4>}
                                                            {Array.isArray(item.documents) &&
                                                                item.documents.map((doc, docIndex) => (
                                                                    <div key={docIndex} className="document-box">
                                                                        <div className="document-header">
                                                                            <span className="document-name">{doc.name}</span>
                                                                        </div>
                                                                        <div className="document-actions">
                                                                            <a href={doc.url} target="_blank" rel="noopener noreferrer" className="view-link">
                                                                                <EyeOutlined title="View" />
                                                                            </a>
                                                                            <a href={doc.url} download className="download-link">
                                                                                <DownloadOutlined title="Download" />
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                        </div>
                                                    ))}

                                            </ul>
                                            // <ul className="section-content">
                                            //     {items.map((item, index) => (
                                            //         <li key={index} className="item-row">
                                            //             <span>{item}</span>
                                            //             <div className="icons">
                                            //                 <EyeOutlined title="View" />
                                            //                 <DownloadOutlined title="Download" />
                                            //             </div>
                                            //         </li>
                                            //     ))}
                                            // </ul>
                                        )}
                                    </div>
                                ))}

                                {/* <button className="more-button">
                                    <span className="button-text">More</span>
                                    <ArrowRightOutlined />
                                </button> */}


                                {sections.length > 7 && (
                                    <button
                                        className="more-button"
                                        onClick={() => setShowAllSections(prev => !prev)}
                                    >
                                        <span className="button-text">
                                            {showAllSections ? 'Less' : 'More'}
                                        </span>
                                        {showAllSections ? <ArrowLeftOutlined /> : <ArrowRightOutlined />}
                                    </button>
                                )}


                            </div>
                        </div>
                    </div>
                    <div className="scroll-section" ref={contactRef}>
                        {/* Contact Us Section Starts */}
                        <h1 className='contactUs'>
                            Contact Us
                        </h1>

                        <hr className='hrline'></hr>

                        <div className="contactUsCard">
                            <Card
                                className="contactUs1"
                                hoverable
                            >
                                <h3 className='contactClix'>
                                    Clix Housing Finance Limited
                                </h3>
                                <hr className='hrline'></hr>
                                <div className="contactUs1AddDesc">
                                    Corporate Address: 6th Floor, Good Earth<br />
                                    Business Bay-2, Sector-58, Gurugram -122102<br />
                                    Registered Address: W2/14, First Floor, West<br />
                                    Patel Nagar, New Delhi-110008<br />
                                    Phn: +91-120-6465400<br />
                                    Email: hello@clix.capital
                                </div>
                            </Card>
                        </div>
                        {/* easy peasy */}

                        <h1 className='branchaddress'>
                            Branch Address
                        </h1>

                        <hr className='hrline'></hr>

                        <div className="branches-wrapper">

                            <div className="branches">
                                <Card
                                    className="delhiaddress"
                                    hoverable
                                >
                                    <h3 className='delhicard'>
                                        Delhi
                                    </h3>
                                    <hr className='hrline'></hr>
                                    <div className="delhiAddDesc">
                                        W2/14, 1st Floor, West Patel Nagar,<br />
                                        Delhi, 110008<br />

                                    </div>
                                </Card>
                                <Card
                                    className="gurugramCard"
                                    hoverable
                                >
                                    <h3 className='gurugramTitle'>
                                        Haryana
                                    </h3>
                                    <hr className='hrline'></hr>
                                    <div className="gurugramAddDesc">
                                        6th Floor, Good Earth Business Bay-II,<br />
                                        Sector 58, Gurugram,<br />
                                        Harayana-122102
                                    </div>
                                </Card>

                                <Card
                                    className="rajasthanCard"
                                    hoverable
                                >
                                    <h3 className='rajasthanTitle'>
                                        Rajasthan
                                    </h3>
                                    <hr className='hrline'></hr>
                                    <div className="rajasthanAddDesc">
                                        801-803, 8th Floor Diamond Tower,<br />
                                        Neelkanth Colony,Purani Chungi, DCM,<br />
                                        Ajmer Road, Jaipur, Rajasthan-302021
                                    </div>
                                </Card>

                                <Card
                                    className="chandigarhCard"
                                    hoverable
                                >
                                    <h3 className='chandigarhTitle'>
                                        Chandigarh
                                    </h3>
                                    <hr className='hrline'></hr>
                                    <div className="chandigarhAddDesc">
                                        302-A, 3rd Floor, SCO 120-121-122,<br />
                                        Sector 17C, Chandigarh-160017<br />
                                    </div>
                                </Card>

                                <Card
                                    className="gujaratCard"
                                    hoverable
                                >
                                    <h3 className='gujaratTitle'>
                                        Gujarat
                                    </h3>
                                    <hr className='hrline'></hr>
                                    <div className="gujaratAddDesc">
                                        Office no. 304, 305 & 306, 3rd Floor,Sheth,
                                        Corporate Tower, Opp, Nagri Hospital Road,
                                        Ellis bridge, Ahmedabad-380006
                                    </div>
                                </Card>

                                <Card
                                    className="gujarat1Card"
                                    hoverable
                                >
                                    <h3 className='gujarat1Title'>
                                        Gujarat
                                    </h3>
                                    <hr className='hrline'></hr>
                                    <div className="gujarat1AddDesc">
                                        Office no. 513, Runway Heights,<br />
                                        Nr Ayodhya Chowk, 150 Feet Ring Road,<br />
                                        Rajkot-360006, Gujarat
                                    </div>
                                </Card>
                            </div>
                        </div>
                        {/* Contact Section */}</div>
                    {/* Super div block */}
                </div>
            </Content >

            

            <Footers
                refs={{
                    homeRef,
                    aboutRef,
                    teamRef,
                    documentsRef,
                    contactRef,
                }}
                onOpenPolicy={() => setPolicyOpen(true)}
            />

<CookieBanner onOpenPolicy={openPolicy} />

            <Modal
                open={policyOpen}
                onCancel={() => setPolicyOpen(false)}
                footer={null}
                width={800}
                bodyStyle={{ maxHeight: '70vh', overflowY: 'auto' }}  // scroll inside modal
            >
                <PrivacyPolicyContent />
            </Modal>

        </>
    );

}

export default Home;
